/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePrice } from './BasePrice';
import { TenantOfTenantPrice } from './TenantOfTenantPrice';
const TenantPriceParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['tenant', TenantOfTenantPrice]]), BasePrice);
export class TenantPrice extends BasePrice {
    static decode(input) {
        return TenantPriceParser.decode(input).map(res => new TenantPrice(res));
    }
    static unsafeDecode(input) {
        return TenantPrice.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantPriceParser.encode(data);
    }
    static schema() {
        return TenantPriceParser.schema();
    }
}
